import CPageTitle from 'components/pageTitle/Index'
import CPagination from 'components/pagination/Index.vue'
import CSidebar from 'components/sidebar/Index.vue'
import CAppbar from 'components/appbar/Index.vue'
import CActions from 'components/c-actions/Index.vue'
import CModalMessage from 'components/modal-message/Index.vue'
import CCheckbox from 'components/c-checkbox/Index.vue'
import CCalendar from 'components/calendar/Index.vue'
import CConfirmPayment from 'components/confirm-payment/Index.vue'
import CPaymentModal from 'components/payment-modal/Index.vue'

export default {
  CPageTitle,
  CPagination,
  CSidebar,
  CAppbar,
  CActions,
  CModalMessage,
  CCheckbox,
  CCalendar,
  CConfirmPayment,
  CPaymentModal,
}
